exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".lp-active-title[data-v-d393bed2]{font-size:.9rem;margin-top:6px;margin-right:15px}.lp-active-count[data-v-d393bed2]{font-size:.9rem;margin-top:6px;margin-left:15px}", ""]);

// exports
